import MutualUserResult from '../result/MutualUserResult';
import ServerFacade from '../network/ServerFacade';
import LogoutResult from '../result/LogoutResult';
import GetStripeSubscriptionResult from '../result/GetStripeSubscriptionResult';
import Config from '../model/config';
/**
 *  This class acts as an interface to log in a user
 *  It also has a method to parse the information contained in the photos
 *  belonging to a user
 */


class MutualDAO {

	static async getUserInstance(): Promise<MutualUserResult> {
		const response = await ServerFacade.getUserInstance();


		try {
			return new MutualUserResult(
				true,
				'Instance Gotten',
				response.id,
				response.first_name,
				response.last_name,
				response.photos[0].url_hd,
				response.p_enabled

			);
		} catch {
			return new MutualUserResult(
				false,
				'Error getting instance',
				'-1',
				'none',
				'none',
				'none',
				false
			);
		}
	}

	// logoutResponse could either be true or false, depending if the user was logged out or not
	static async userLogout(): Promise<LogoutResult> {
		const logoutResponse = await ServerFacade.userLogout();

		try{
			if(logoutResponse.status === 200){
				return new LogoutResult(true, 'Logout Successful', true)
			}
			else{
				return new LogoutResult(false, 'Logout Unsucessful', false)
			}
		}
		catch{
			return new LogoutResult(false, 'Logout Unsucessful', false)
		}
	}

	static async getActiveSubscription(id : string): Promise<GetStripeSubscriptionResult> {
		const activeSubscription = await ServerFacade.getActiveSubscription(id);

		try{
			if(activeSubscription.active_subscription === null){
				return new GetStripeSubscriptionResult(true, 'Success', null)
			}
			return new GetStripeSubscriptionResult(true, 'Success', activeSubscription.active_subscription)
		}
		catch(error){
			console.log(error)
			return new GetStripeSubscriptionResult(false, 'Failed', null)

		}
	}

	static async getConfigs(): Promise<Config> {
		try {
			return await ServerFacade.getConfigs();
		}
		catch {
			return new Config();
		}
	}

}

export default MutualDAO;
